import { jsx as d, jsxs as f } from "react/jsx-runtime";
import { useDeterminateState as I } from "@telegraph/helpers";
import { Lucide as T, Icon as O } from "@telegraph/icon";
import { Stack as P } from "@telegraph/layout";
import { useStyleEngine as V } from "@telegraph/style-engine";
import { Text as E } from "@telegraph/typography";
import L from "clsx";
import g from "react";
const R = {
  default_buttonShadowColor: {
    cssVar: "--tgph-button-default-shadow",
    value: "inset 0 0 0 1px var(--tgph-VARIABLE)"
  },
  hover_buttonShadowColor: {
    cssVar: "--tgph-button-hover-shadow",
    value: "inset 0 0 0 1px var(--tgph-VARIABLE)"
  },
  focus_buttonShadowColor: {
    cssVar: "--tgph-button-focus-shadow",
    value: "inset 0 0 0 1px var(--tgph-VARIABLE)"
  },
  active_buttonShadowColor: {
    cssVar: "--tgph-button-active-shadow",
    value: "inset 0 0 0 1px var(--tgph-VARIABLE)"
  }
}, M = {
  solid: {
    default: {
      backgroundColor: "gray-12",
      hover_backgroundColor: "gray-11",
      focus_backgroundColor: "gray-10",
      active_backgroundColor: "gray-10"
    },
    accent: {
      backgroundColor: "accent-9",
      hover_backgroundColor: "accent-10",
      focus_backgroundColor: "accent-11",
      active_backgroundColor: "accent-11"
    },
    red: {
      backgroundColor: "red-9",
      hover_backgroundColor: "red-10",
      focus_backgroundColor: "red-11",
      active_backgroundColor: "red-11"
    },
    gray: {
      backgroundColor: "gray-9",
      hover_backgroundColor: "gray-10",
      focus_backgroundColor: "gray-11",
      active_backgroundColor: "gray-11"
    },
    green: {
      backgroundColor: "green-9",
      hover_backgroundColor: "green-10",
      focus_backgroundColor: "green-11",
      active_backgroundColor: "green-11"
    },
    blue: {
      backgroundColor: "blue-9",
      hover_backgroundColor: "blue-10",
      focus_backgroundColor: "blue-11",
      active_backgroundColor: "blue-11"
    },
    yellow: {
      backgroundColor: "yellow-9",
      hover_backgroundColor: "yellow-10",
      focus_backgroundColor: "yellow-11",
      active_backgroundColor: "yellow-11"
    },
    purple: {
      backgroundColor: "purple-9",
      hover_backgroundColor: "purple-10",
      focus_backgroundColor: "purple-11",
      active_backgroundColor: "purple-11"
    }
  },
  soft: {
    default: {
      backgroundColor: "gray-3",
      hover_backgroundColor: "gray-4",
      focus_backgroundColor: "gray-5",
      active_backgroundColor: "gray-5"
    },
    gray: {
      backgroundColor: "gray-3",
      hover_backgroundColor: "gray-4",
      focus_backgroundColor: "gray-5",
      active_backgroundColor: "gray-5"
    },
    red: {
      backgroundColor: "red-3",
      hover_backgroundColor: "red-4",
      focus_backgroundColor: "red-5",
      active_backgroundColor: "red-5"
    },
    accent: {
      backgroundColor: "accent-3",
      hover_backgroundColor: "accent-4",
      focus_backgroundColor: "accent-5",
      active_backgroundColor: "accent-5"
    },
    green: {
      backgroundColor: "green-3",
      hover_backgroundColor: "green-4",
      focus_backgroundColor: "green-5",
      active_backgroundColor: "green-5"
    },
    blue: {
      backgroundColor: "blue-3",
      hover_backgroundColor: "blue-4",
      focus_backgroundColor: "blue-5",
      active_backgroundColor: "blue-5"
    },
    yellow: {
      backgroundColor: "yellow-3",
      hover_backgroundColor: "yellow-4",
      focus_backgroundColor: "yellow-5",
      active_backgroundColor: "yellow-5"
    },
    purple: {
      backgroundColor: "purple-3",
      hover_backgroundColor: "purple-4",
      focus_backgroundColor: "purple-5",
      active_backgroundColor: "purple-5"
    }
  },
  outline: {
    default: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "gray-6",
      hover_buttonShadowColor: "gray-7",
      focus_buttonShadowColor: "gray-8",
      active_buttonShadowColor: "gray-8"
    },
    gray: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "gray-6",
      hover_buttonShadowColor: "gray-7",
      focus_buttonShadowColor: "gray-8",
      active_buttonShadowColor: "gray-8"
    },
    red: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "red-6",
      hover_buttonShadowColor: "red-7",
      focus_buttonShadowColor: "red-8",
      active_buttonShadowColor: "red-8"
    },
    accent: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "accent-6",
      hover_buttonShadowColor: "accent-7",
      focus_buttonShadowColor: "accent-8",
      active_buttonShadowColor: "accent-8"
    },
    green: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "green-6",
      hover_buttonShadowColor: "green-7",
      focus_buttonShadowColor: "green-8",
      active_buttonShadowColor: "green-8"
    },
    blue: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "blue-6",
      hover_buttonShadowColor: "blue-7",
      focus_buttonShadowColor: "blue-8",
      active_buttonShadowColor: "blue-8"
    },
    yellow: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "yellow-6",
      hover_buttonShadowColor: "yellow-7",
      focus_buttonShadowColor: "yellow-8",
      active_buttonShadowColor: "yellow-8"
    },
    purple: {
      backgroundColor: "surface-1",
      default_buttonShadowColor: "purple-6",
      hover_buttonShadowColor: "purple-7",
      focus_buttonShadowColor: "purple-8",
      active_buttonShadowColor: "purple-8"
    }
  },
  ghost: {
    default: {
      backgroundColor: "transparent",
      hover_backgroundColor: "gray-3",
      focus_backgroundColor: "gray-4",
      active_backgroundColor: "gray-4"
    },
    gray: {
      backgroundColor: "transparent",
      hover_backgroundColor: "gray-3",
      focus_backgroundColor: "gray-4",
      active_backgroundColor: "gray-4"
    },
    red: {
      backgroundColor: "transparent",
      hover_backgroundColor: "red-3",
      focus_backgroundColor: "red-4",
      active_backgroundColor: "red-4"
    },
    accent: {
      backgroundColor: "transparent",
      hover_backgroundColor: "accent-3",
      focus_backgroundColor: "accent-4",
      active_backgroundColor: "accent-4"
    },
    green: {
      backgroundColor: "transparent",
      hover_backgroundColor: "green-3",
      focus_backgroundColor: "green-4",
      active_backgroundColor: "green-4"
    },
    blue: {
      backgroundColor: "transparent",
      hover_backgroundColor: "blue-3",
      focus_backgroundColor: "blue-4",
      active_backgroundColor: "blue-4"
    },
    yellow: {
      backgroundColor: "transparent",
      hover_backgroundColor: "yellow-3",
      focus_backgroundColor: "yellow-4",
      active_backgroundColor: "yellow-4"
    },
    purple: {
      backgroundColor: "transparent",
      hover_backgroundColor: "purple-3",
      focus_backgroundColor: "purple-4",
      active_backgroundColor: "purple-4"
    }
  }
}, B = {
  default: {
    0: {
      w: "auto",
      h: "5",
      gap: "1",
      px: "1",
      rounded: "2"
    },
    1: {
      w: "auto",
      h: "6",
      gap: "1",
      px: "2",
      rounded: "2"
    },
    2: {
      w: "auto",
      h: "8",
      gap: "2",
      px: "3",
      rounded: "2"
    },
    3: {
      w: "auto",
      h: "10",
      gap: "3",
      px: "4",
      rounded: "3"
    }
  },
  "icon-only": {
    0: {
      w: "5",
      h: "5",
      gap: "0",
      px: "0",
      rounded: "2"
    },
    1: {
      w: "6",
      h: "6",
      gap: "0",
      px: "0",
      rounded: "2"
    },
    2: {
      w: "8",
      h: "8",
      gap: "0",
      px: "0",
      rounded: "2"
    },
    3: {
      w: "10",
      h: "10",
      gap: "0",
      px: "0",
      rounded: "3"
    }
  }
}, N = {
  0: "0",
  1: "1",
  2: "2",
  3: "3"
}, j = {
  solid: {
    default: "white",
    gray: "white",
    red: "white",
    accent: "white",
    green: "white",
    blue: "white",
    yellow: "white",
    purple: "white",
    disabled: "disabled"
  },
  soft: {
    default: "default",
    gray: "gray",
    red: "red",
    accent: "accent",
    green: "green",
    blue: "blue",
    yellow: "yellow",
    purple: "purple",
    disabled: "disabled"
  },
  outline: {
    default: "default",
    gray: "gray",
    red: "red",
    accent: "accent",
    green: "green",
    blue: "blue",
    yellow: "yellow",
    purple: "purple",
    disabled: "disabled"
  },
  ghost: {
    default: "default",
    gray: "gray",
    red: "red",
    accent: "accent",
    green: "green",
    blue: "blue",
    yellow: "yellow",
    purple: "purple",
    disabled: "disabled"
  }
}, z = {
  0: "0",
  1: "1",
  2: "2",
  3: "3"
}, D = {
  solid: {
    default: "white",
    gray: "white",
    red: "white",
    accent: "white",
    green: "white",
    blue: "white",
    yellow: "white",
    purple: "white",
    disabled: "disabled"
  },
  soft: {
    default: "default",
    accent: "accent",
    gray: "gray",
    red: "red",
    green: "green",
    blue: "blue",
    yellow: "yellow",
    purple: "purple",
    disabled: "disabled"
  },
  outline: {
    default: "default",
    accent: "accent",
    gray: "gray",
    red: "red",
    green: "green",
    blue: "blue",
    yellow: "yellow",
    purple: "purple",
    disabled: "disabled"
  },
  ghost: {
    default: "gray",
    accent: "accent",
    gray: "gray",
    red: "red",
    green: "green",
    blue: "blue",
    yellow: "yellow",
    purple: "purple",
    disabled: "disabled"
  }
}, Z = {
  default: "secondary",
  "icon-only": "primary"
}, k = g.createContext({
  variant: "solid",
  size: "2",
  color: "default",
  state: "default",
  layout: "default",
  active: !1
}), U = (o) => o.disabled ? "disabled" : o.state === "loading" ? "loading" : o.active ? "active" : o.state, w = ({
  as: o,
  variant: r = "solid",
  size: n = "2",
  color: e = "default",
  state: u = "default",
  active: t = !1,
  disabled: l,
  className: c,
  children: a,
  ...i
}) => {
  const p = U({ state: u, disabled: l, active: t }), b = I({
    value: p,
    determinateValue: "loading",
    minDurationMs: 1200
  }), { styleProp: x, otherProps: m } = V({
    props: M[r][e],
    cssVars: R
  }), A = l ? "button" : o, _ = g.useMemo(() => {
    var y;
    const s = g.Children.toArray(a);
    if ((s == null ? void 0 : s.length) === 1 && g.isValidElement(s[0])) {
      const h = s[0];
      if ((y = h == null ? void 0 : h.props) != null && y.icon)
        return "icon-only";
    }
    return "default";
  }, [a]);
  return /* @__PURE__ */ d(
    k.Provider,
    {
      value: { variant: r, size: n, color: e, state: b, layout: _, active: t },
      children: /* @__PURE__ */ f(
        P,
        {
          as: A || "button",
          className: L("tgph-button", c),
          display: "inline-flex",
          align: "center",
          justify: "center",
          ...B[_][n],
          style: x,
          "data-tgph-button": !0,
          "data-tgph-button-layout": _,
          "data-tgph-button-state": b,
          "data-tgph-button-variant": r,
          "data-tgph-button-color": e,
          disabled: b === "disabled" || b === "loading",
          ...m,
          ...i,
          children: [
            b === "loading" && /* @__PURE__ */ d(
              C,
              {
                icon: T.LoaderCircle,
                "aria-hidden": !0,
                "data-tgph-button-loading-icon": !0
              }
            ),
            a
          ]
        }
      )
    }
  );
}, C = ({
  size: o,
  color: r,
  variant: n,
  icon: e,
  alt: u,
  "aria-hidden": t,
  internal_iconType: l,
  ...c
}) => {
  const a = g.useContext(k), i = {
    size: o ?? z[a.size],
    color: r ?? D[a.variant][a.state === "disabled" ? "disabled" : a.color],
    variant: n ?? Z[a.layout]
  }, p = u ? { alt: u } : { "aria-hidden": t };
  return a.state === "loading" && l === "leading" ? null : /* @__PURE__ */ d(
    O,
    {
      icon: e,
      "data-button-icon": !0,
      "data-button-icon-color": i.color,
      ...p,
      ...i,
      ...c
    }
  );
}, v = ({
  as: o,
  color: r,
  size: n,
  weight: e = "medium",
  style: u,
  ...t
}) => {
  const l = g.useContext(k), c = r ?? j[l.variant][l.state === "disabled" ? "disabled" : l.color];
  return /* @__PURE__ */ d(
    E,
    {
      as: o || "span",
      color: c,
      size: n ?? N[l.size],
      weight: e,
      internal_optionalAs: !0,
      "data-button-text": !0,
      "data-button-text-color": c,
      style: {
        textDecoration: "none",
        whiteSpace: "nowrap",
        ...u
      },
      ...t
    }
  );
}, S = ({
  leadingIcon: o,
  trailingIcon: r,
  icon: n,
  children: e,
  ...u
}) => {
  const t = o || n;
  return /* @__PURE__ */ f(w, { ...u, children: [
    t && /* @__PURE__ */ d(C, { ...t, internal_iconType: "leading" }),
    e && /* @__PURE__ */ d(v, { children: e }),
    r && /* @__PURE__ */ d(C, { ...r, internal_iconType: "trailing" })
  ] });
};
Object.assign(S, {
  Root: w,
  Icon: C,
  Text: v
});
const Q = S;
export {
  Q as Button
};
//# sourceMappingURL=index.mjs.map
